<template>
  <nx-board-dayparting-list :board-id="boardId" @loaded="finishLoading"></nx-board-dayparting-list>
</template>

<script>
import BasePage from '@/pages/BasePage';
import NxBoardDaypartingList from '@/modules/board/editor/components/BoardDaypartingList';

export default {
  extends: BasePage,
  props: {
    boardId: {
      type: Number,
    },
  },
  components: {
    NxBoardDaypartingList,
  },
};
</script>
